import React from "react";
import { Button, Container, Divider, Grid, Header } from "semantic-ui-react";
import "../components/common/KontaktBoks.css";
import ImageLink from "./common/ImageLink";
import appRoutes from "../routes/appRoutes";
import LetsikringVedKritiskSygdomImg from "../images/letsikringvedkritisksygdom.jpg";
import LetsikringAfHelbredImg from "../images/letsikringafhelbred.jpg";
import AutoAccordion from "./common/AutoAccordion";

const Kontakt = (props) => {
  return (
    <div>
      <Header as="h1" textAlign="center">
        Brug din forsikring
      </Header>
      <Divider hidden />
      <Container text>
        <p>
          Skal du bruge din forsikring? Så skal du kontakte PFA Pension, som
          Letpension samarbejder med om pensions- og forsikringsløsninger.{" "}
        </p>
        <p>Det er nemt og hurtigt via PFA’s digitale løsning:</p>

        <Divider hidden />
        <Button color="teal" as="a" href="https://mit.pfa.dk/" target="blank">
          Brug din forsikring
        </Button>
        <Divider hidden />

        <p>
          Har du spørgsmål, inden du går i gang, kan du ringe til PFA på 70 80
          55 00.
        </p>
        <p>
          Hvis du ønsker rådgivning om dine forsikringer, skal du kontakte dit
          pengeinstitut.
        </p>

        <Divider hidden />
        <Divider hidden />

        <AutoAccordion activeIndex={-1}>
          <AutoAccordion.Item title="Sådan bruger du din Letsikring af helbred og Online Sundhedshjælp">
            <p>
              Med en Letsikring af helbred kan du få hjælp til behandling eller
              udredning, hvis du har gener, bliver syg eller kommer til skade.
            </p>
            <p>
              Læs om{" "}
              <a href="/produktet/letsikringafhelbred">Letsikring af helbred</a>
            </p>

            <h4>Sådan gør du</h4>
            <ol>
              <li>
                Log ind på{" "}
                <a href="https://mit.pfa.dk/" target="blank">
                  PFA’s digitale løsning
                </a>
              </li>
              <ul>
                <li>
                  Gå til <i>Dine forsikringer</i>, vælg Letsikring af helbred,
                  og klik på <i>Ansøg om behandling.</i>
                </li>
                <li>Hav din lægehenvisning klar, hvis du har en.</li>
              </ul>
              <li>Udfyld ansøgningen</li>
              <ul>
                <li>Besvar spørgsmålene, og beskriv din situation.</li>
                <li>Du kan gemme undervejs og fortsætte senere.</li>
                <li>Du får svar inden for 24 timer.</li>
              </ul>
              <li>Start behandlingen</li>
              <ul>
                <li>
                  Vi hjælper dig med at finde en behandler i vores netværk.
                </li>
                <li>
                  Skal du til fysioterapi eller kiropraktik, kan du selv vælge
                  behandler.
                </li>
                <li>
                  Udgiften afregnes normalt direkte med behandlingsstedet.
                </li>
              </ul>
            </ol>

            <h4>Online Sundhedshjælp</h4>
            <p>Du har også adgang til online sundhedshjælp:</p>
            <ul>
              <li>
                Få online hjælp hos læge, fysioterapeut, psykolog,
                familierådgiver eller coach.
              </li>
              <li>
                Ingen lægehenvisning eller forudgående kontakt til PFA er
                nødvendig.
              </li>
              <li>Book tid direkte og hurtigt.</li>
            </ul>
            <Button color="teal" as="a" href="/onlinesundhedshjaelp">
              Book Online Sundhedshjælp
            </Button>
          </AutoAccordion.Item>
          <AutoAccordion.Item title="Sådan bruger du din Letsikring ved sygdom og EarlyCare">
            <p>
              Med en Letsikring ved sygdom får du økonomisk tryghed, hvis du
              bliver alvorligt syg og mister arbejdsevnen. Forsikringen kan
              udbetale et beløb, hvis du bliver syg og mister din arbejdsevne,
              og du kan også få hjælp til at komme tilbage til arbejdet igen.
            </p>
            <h4>Sådan gør du</h4>
            <ol>
              <li>
                Fortæl PFA om dit tab af arbejdsevne – enten{" "}
                <a href="https://mit.pfa.dk/" target="blank">
                  online
                </a>{" "}
                eller på 70 80 55 00.
              </li>
              <li>
                PFA kontakter PFA dig og aftaler det videre forløb, når PFA har
                behandlet din henvendelse.
              </li>
            </ol>

            <h4>
              EarlyCare – hurtig hjælp, hvis du er sygemeldt eller i risiko for
              at blive det
            </h4>
            <p>
              Med Letsikring ved sygdom har du adgang til EarlyCare, som kan
              hjælpe dig med at undgå en lang sygemelding og komme godt tilbage
              på arbejde.
            </p>
            <p>Du kan bl.a. få:</p>
            <ul>
              <li>Rådgivning og sparring</li>
              <li>En personlig Health Guide, som følger dig løbende</li>
              <li>Hjælp til at sammensætte et forløb, der passer til dig.</li>
            </ul>
            <p>Ring til 70 80 55 00, hvis du vil bruge EarlyCare.</p>
          </AutoAccordion.Item>
          <AutoAccordion.Item title="Sådan bruger du din Letsikring ved kritisk sygdom">
            <p>
              Med en Letsikring ved kritisk sygdom kan du sikre dig et
              skattefrit beløb, hvis du bliver ramt af en alvorlig sygdom, fx
              kræft eller en hjerneblødning.
            </p>
            <p>
              Du kan bruge pengene, som du vil – fx til at tilpasse hjemmet
              eller tage på rekreation.
            </p>

            <h4>Sådan gør du</h4>
            <ol>
              <li>
                Fortæl PFA om din kritiske sygdom – enten{" "}
                <a href="https://mit.pfa.dk/" target="blank">
                  online
                </a>{" "}
                eller på 70 80 55 00.
              </li>
              <li>
                Hvis din sygdom er dækket, udbetales beløbet til din NemKonto.
              </li>
            </ol>
            <p>
              PFA er tilmeldt Sundhedsstyrelsens samkørsel med
              Landspatientregisteret. Derfor vil du modtage et brev fra
              hospitalet om mulig udbetaling.
            </p>
          </AutoAccordion.Item>
          <AutoAccordion.Item title="Sådan kommer din Letsikring ved død / Letsikring af barn ved død til udbetaling">
            <p>
              Med en Letsikring ved død/Letsikring af barn ved død sikrer du, at
              dine efterladte får udbetalt penge i tilfælde af dit dødsfald.
            </p>
            <ul>
              <li>PFA får automatisk besked fra CPR-registeret.</li>
              <li>
                PFA sender en blanket til boet, som skal udfyldes af de
                efterladte.
              </li>
              <li>
                PFA kontakter de efterladte, hvis der er behov for supplerende
                oplysninger eller skifteretsattest.
              </li>
            </ul>
            <p>
              Er du efterladt, er du velkommen til at ringe til PFA på 70 80 55
              00.
            </p>
          </AutoAccordion.Item>
        </AutoAccordion>
      </Container>

      <Divider hidden />
      <Divider hidden />
      <Divider hidden />

      <Grid centered stackable columns={2}>
        <Grid.Row>
          <ImageLink
            imageSrc={LetsikringAfHelbredImg}
            text="Letsikring af helbred"
            link={appRoutes.LETSIKRING_AF_HELBRED}
          />
          <ImageLink
            imageSrc={LetsikringVedKritiskSygdomImg}
            text="Letsikring ved kritisk sygdom"
            link={appRoutes.LETSIKRING_VED_KRITISK_SYGDOM}
          />
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default Kontakt;
